import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  EditButton,
  DeleteButton,
  ImageField,
  ArrayField,
  SingleFieldList,
  ChipField,
  RecordContext,
  ReferenceField,
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { CustomEmailField } from "../CustomEmailField";
import SimpleChipField from "../SimpleChipField";
import { countries } from "../../data";

const useImageFieldStyles = makeStyles((theme) => ({
  image: {
    width: 80,
  },
}));

const ProductList = (props) => {
  const imageFieldClasses = useImageFieldStyles();

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <ReferenceField source="brandId" reference="brands" resource="brands">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="amaValue" />
        <TextField source="type" />
        <ImageField
          source="image.src"
          label="Product Image"
          classes={imageFieldClasses}
        />
      </Datagrid>
    </List>
  );
};

export default ProductList;
